/*
 * @Author: your name
 * @Date: 2021-07-07 15:41:11
 * @LastEditTime: 2021-07-15 11:40:58
 * @LastEditors: lyy
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\router\ProjectProgress.js
 */
const projectProgress = [
  // path: '/projectProgress',
  // name: 'projectProgress',
  // component: () => import('../views/ProjectProgress/index.vue'),
  // meta: {
  //   keepAlive: false,
  //   requiresAuth: true
  // },
  // redirect: 'projectProgress/index',
  // children: []
  {
    path: '/project-progress-home', //项目进度查询和办理主页
    name: 'projectProgressHome',
    component: () => import('../views/ProjectProgress/ProjectProgressHome.vue')
    // meta: {
    //   requiresAuth: true
    //   // title: '投票管理'   // 标题设置
    // }
  },
  {
    path: '/project-progress-detail', // 项目进度查询和办理详情
    name: 'projectProgressDetail',
    component: () =>
      import('../views/ProjectProgress/ProjectProgressDetail.vue')
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/project-progress-detail-info', // 项目进度查询和办理详情基本信息
    name: 'projectProgressDetailInfo',
    component: () =>
      import('../views/ProjectProgress/ProjectProgressDetailInfo.vue')
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/project-progress-update-delegation', // 项目进度查询和办理 更改委托信息
    name: 'projectProgressUpdateDelegation',
    component: () =>
      import('../views/ProjectProgress/ProjectProgressUpdateDelegation.vue')
    // meta: {
    //   requiresAuth: true
    // }
  },
  {
    path: '/project-progress-satisfy-rate', // 项目进度查询和办理 满意度评价
    name: 'projectProgressSatisfyRate',
    component: () =>
      import('../views/ProjectProgress/ProjectProgressSatisfyRate.vue')
    // meta: {
    //   requiresAuth: true
    // }
  }
]

export default projectProgress
